import { lazy } from 'react';
import type { PropertySectionDef } from './context';

// Pages and tabs load when first opened (NFR-04).
const RegisterTab = lazy(() => import('./components/RegisterTabs').then((m) => ({ default: m.RegisterTab })));
const ImportTab = lazy(() => import('./components/RegisterTabs').then((m) => ({ default: m.ImportTab })));
const MigrationTab = lazy(() => import('./components/MigrationTab').then((m) => ({ default: m.MigrationTab })));
const LeaseAccountingTab = lazy(() => import('./components/BillingTabs3').then((m) => ({ default: m.LeaseAccountingTab })));
const SettingsTab = lazy(() => import('./components/SettingsTabs').then((m) => ({ default: m.SettingsTab })));
const OwnersTab = lazy(() => import('./components/StructureTabs').then((m) => ({ default: m.OwnersTab })));
const PortfoliosTab = lazy(() => import('./components/StructureTabs').then((m) => ({ default: m.PortfoliosTab })));
const LocationTypesTab = lazy(() => import('./components/StructureTabs').then((m) => ({ default: m.LocationTypesTab })));
const PacksTab = lazy(() => import('./components/PacksTab').then((m) => ({ default: m.PacksTab })));
const AccessTab = lazy(() => import('./components/AccessTabs').then((m) => ({ default: m.AccessTab })));
const PortalUsersTab = lazy(() => import('./components/AccessTabs').then((m) => ({ default: m.PortalUsersTab })));
const AgreementsTab = lazy(() => import('./components/LeasingTabs').then((m) => ({ default: m.AgreementsTab })));
const EnquiriesTab = lazy(() => import('./components/LeasingTabs').then((m) => ({ default: m.EnquiriesTab })));
const TendersTab = lazy(() => import('./components/LeasingTabs').then((m) => ({ default: m.TendersTab })));
const CriticalDatesTab = lazy(() => import('./components/LeasingTabs').then((m) => ({ default: m.CriticalDatesTab })));
const AgreementTypesTab = lazy(() => import('./components/LeasingConfigTabs').then((m) => ({ default: m.AgreementTypesTab })));
const ClauseTemplatesTab = lazy(() => import('./components/LeasingConfigTabs').then((m) => ({ default: m.ClauseTemplatesTab })));
const RatesTab = lazy(() => import('./components/LeasingConfigTabs').then((m) => ({ default: m.RatesTab })));
const RunsTab = lazy(() => import('./components/BillingTabs').then((m) => ({ default: m.RunsTab })));
const InvoicesTab = lazy(() => import('./components/BillingTabs').then((m) => ({ default: m.InvoicesTab })));
const DebtorsTab = lazy(() => import('./components/BillingTabs').then((m) => ({ default: m.DebtorsTab })));
const RentRollTab = lazy(() => import('./components/BillingTabs').then((m) => ({ default: m.RentRollTab })));
const TurnoverTab = lazy(() => import('./components/BillingTabs2').then((m) => ({ default: m.TurnoverTab })));
const UtilitiesTab = lazy(() => import('./components/BillingTabs2').then((m) => ({ default: m.UtilitiesTab })));
const ServiceChargesTab = lazy(() => import('./components/BillingTabs2').then((m) => ({ default: m.ServiceChargesTab })));
const CreditsTab = lazy(() => import('./components/BillingTabs2').then((m) => ({ default: m.CreditsTab })));
const OwnersStatementsTab = lazy(() => import('./components/BillingTabs2').then((m) => ({ default: m.OwnersTab })));
const FiscalTab = lazy(() => import('./components/BillingTabs2').then((m) => ({ default: m.FiscalTab })));
const AssetsTab = lazy(() => import('./components/AssetsTabs').then((m) => ({ default: m.AssetsTab })));
const AssetClassesTab = lazy(() => import('./components/AssetsTabs').then((m) => ({ default: m.AssetClassesTab })));
const JobPlansTab = lazy(() => import('./components/AssetsTabs').then((m) => ({ default: m.JobPlansTab })));
const PpmTab = lazy(() => import('./components/AssetsTabs').then((m) => ({ default: m.PpmTab })));
const StatutoryTab = lazy(() => import('./components/AssetsTabs').then((m) => ({ default: m.StatutoryTab })));
const WorkOrdersTab = lazy(() => import('./components/WorkTabs').then((m) => ({ default: m.WorkOrdersTab })));
const FaultsTab = lazy(() => import('./components/WorkTabs').then((m) => ({ default: m.FaultsTab })));
const PermitsTab = lazy(() => import('./components/WorkTabs').then((m) => ({ default: m.PermitsTab })));
const PermitKindsTab = lazy(() => import('./components/WorkTabs').then((m) => ({ default: m.PermitKindsTab })));
const CodesTab = lazy(() => import('./components/WorkTabs').then((m) => ({ default: m.CodesTab })));
const SlaTab = lazy(() => import('./components/WorkTabs').then((m) => ({ default: m.SlaTab })));
const ContractorsTab = lazy(() => import('./components/ContractorsTabs').then((m) => ({ default: m.ContractorsTab })));
const ContractorInvoicesTab = lazy(() => import('./components/ContractorInvoicesTab').then((m) => ({ default: m.ContractorInvoicesTab })));
const ContractsTab = lazy(() => import('./components/ContractorsTabs').then((m) => ({ default: m.ContractsTab })));
const ScorecardsTab = lazy(() => import('./components/ContractorsTabs').then((m) => ({ default: m.ScorecardsTab })));
const CostsTab = lazy(() => import('./components/ContractorsTabs').then((m) => ({ default: m.CostsTab })));
const CapitalPlanTab = lazy(() => import('./components/ContractorsTabs').then((m) => ({ default: m.CapitalPlanTab })));
const WarrantyTab = lazy(() => import('./components/ContractorsTabs').then((m) => ({ default: m.WarrantyTab })));
const InspectionsTab = lazy(() => import('./components/AirportTabs').then((m) => ({ default: m.InspectionsTab })));
const FindingsTab = lazy(() => import('./components/AirportTabs').then((m) => ({ default: m.FindingsTab })));
const AirfieldTab = lazy(() => import('./components/AirportTabs').then((m) => ({ default: m.AirfieldTab })));
const ComplianceTab = lazy(() => import('./components/AirportTabs2').then((m) => ({ default: m.ComplianceTab })));
const AirsideTab = lazy(() => import('./components/AirportTabs2').then((m) => ({ default: m.AirsideTab })));
const AvailabilityTab = lazy(() => import('./components/AirportTabs2').then((m) => ({ default: m.AvailabilityTab })));
const CommercialTab = lazy(() => import('./components/AirportTabs2').then((m) => ({ default: m.CommercialTab })));
const BookingsTab = lazy(() => import('./components/SectorTabs').then((m) => ({ default: m.BookingsTab })));
const VisitorsTab = lazy(() => import('./components/SectorTabs').then((m) => ({ default: m.VisitorsTab })));
const FitOutsTab = lazy(() => import('./components/SectorTabs').then((m) => ({ default: m.FitOutsTab })));
const TenantMixTab = lazy(() => import('./components/SectorTabs2').then((m) => ({ default: m.TenantMixTab })));
const CoworkingTab = lazy(() => import('./components/SectorTabs2').then((m) => ({ default: m.CoworkingTab })));
const LandRegisterTab = lazy(() => import('./components/SectorTabs2').then((m) => ({ default: m.LandRegisterTab })));
const SiteRevenueTab = lazy(() => import('./components/SectorTabs2').then((m) => ({ default: m.SiteRevenueTab })));
const AssetVerificationTab = lazy(() => import('./components/SectorTabs2').then((m) => ({ default: m.AssetVerificationTab })));

/**
 * The property module's sections, one per menu item, each with its leaves. The URL's last segment
 * names the leaf, so every tab is a real address; the rights are read once by the page.
 */
export const propertySections = {
  register: {
    area: 'Property', title: 'Register', basePath: '/property/register',
    description: 'Every property and space, from the estate down to the lettable unit, with its areas, status, position, documents and history.',
    views: [
      { key: 'locations', label: 'Locations' },
      { key: 'import', label: 'Import' },
      { key: 'land', label: 'Land register' },
      { key: 'migration', label: 'Migration sheets' },
    ],
    render: (view, ctx) => (view === 'import' ? <ImportTab ctx={ctx} /> : view === 'land' ? <LandRegisterTab /> : view === 'migration' ? <MigrationTab ctx={ctx} /> : <RegisterTab ctx={ctx} />),
  } satisfies PropertySectionDef<'locations' | 'import' | 'land' | 'migration'>,

  leasing: {
    area: 'Property', title: 'Leasing', basePath: '/property/leasing',
    description: 'Agreements from enquiry to exit: the pipeline, the agreements in force, their critical dates, and concession tenders.',
    views: [
      { key: 'agreements', label: 'Agreements' },
      { key: 'enquiries', label: 'Enquiries' },
      { key: 'tenders', label: 'Tenders' },
      { key: 'critical-dates', label: 'Critical dates' },
      { key: 'bookings', label: 'Bookings' },
      { key: 'visitors', label: 'Visitors' },
      { key: 'fit-outs', label: 'Fit-outs' },
      { key: 'tenant-mix', label: 'Tenant mix' },
      { key: 'coworking', label: 'Coworking' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'enquiries': return <EnquiriesTab ctx={ctx} />;
        case 'tenders': return <TendersTab ctx={ctx} />;
        case 'critical-dates': return <CriticalDatesTab ctx={ctx} />;
        case 'bookings': return <BookingsTab ctx={ctx} />;
        case 'visitors': return <VisitorsTab ctx={ctx} />;
        case 'fit-outs': return <FitOutsTab ctx={ctx} />;
        case 'tenant-mix': return <TenantMixTab ctx={ctx} />;
        case 'coworking': return <CoworkingTab />;
        default: return <AgreementsTab ctx={ctx} />;
      }
    },
  } satisfies PropertySectionDef<'agreements' | 'enquiries' | 'tenders' | 'critical-dates' | 'bookings' | 'visitors' | 'fit-outs' | 'tenant-mix' | 'coworking'>,

  billing: {
    area: 'Property', title: 'Billing', basePath: '/property/billing',
    description: 'Billing runs and the invoices they raise in Accounting, receipts and statements, aged debtors and the rent roll, turnover, utilities, service charges, credits, and owner statements.',
    views: [
      { key: 'runs', label: 'Runs' },
      { key: 'invoices', label: 'Invoices' },
      { key: 'debtors', label: 'Debtors' },
      { key: 'rent-roll', label: 'Rent roll' },
      { key: 'turnover', label: 'Turnover' },
      { key: 'utilities', label: 'Utilities' },
      { key: 'service-charges', label: 'Service charges' },
      { key: 'credits', label: 'Credits' },
      { key: 'owners', label: 'Owner statements' },
      { key: 'fiscal', label: 'Fiscal queue' },
      { key: 'sites', label: 'Revenue per site' },
      { key: 'lease-accounting', label: 'Lease accounting' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'invoices': return <InvoicesTab ctx={ctx} />;
        case 'debtors': return <DebtorsTab />;
        case 'rent-roll': return <RentRollTab />;
        case 'turnover': return <TurnoverTab ctx={ctx} />;
        case 'utilities': return <UtilitiesTab ctx={ctx} />;
        case 'service-charges': return <ServiceChargesTab ctx={ctx} />;
        case 'credits': return <CreditsTab ctx={ctx} />;
        case 'owners': return <OwnersStatementsTab ctx={ctx} />;
        case 'lease-accounting': return <LeaseAccountingTab ctx={ctx} />;
        case 'fiscal': return <FiscalTab ctx={ctx} />;
        case 'sites': return <SiteRevenueTab />;
        default: return <RunsTab ctx={ctx} />;
      }
    },
  } satisfies PropertySectionDef<'runs' | 'invoices' | 'debtors' | 'rent-roll' | 'turnover' | 'utilities' | 'service-charges' | 'credits' | 'owners' | 'fiscal' | 'sites' | 'lease-accounting'>,

  assets: {
    area: 'Property', title: 'Assets', basePath: '/property/assets',
    description: 'The maintainable assets on the estate, their classes and condition, the job plans and planned-maintenance schedules, and the statutory inspections due.',
    views: [
      { key: 'assets', label: 'Register' },
      { key: 'ppm', label: 'Planned maintenance' },
      { key: 'statutory', label: 'Statutory' },
      { key: 'job-plans', label: 'Job plans' },
      { key: 'classes', label: 'Asset classes' },
      { key: 'verification', label: 'Asset verification' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'ppm': return <PpmTab ctx={ctx} />;
        case 'statutory': return <StatutoryTab />;
        case 'job-plans': return <JobPlansTab ctx={ctx} />;
        case 'classes': return <AssetClassesTab ctx={ctx} />;
        case 'verification': return <AssetVerificationTab ctx={ctx} />;
        default: return <AssetsTab ctx={ctx} />;
      }
    },
  } satisfies PropertySectionDef<'assets' | 'ppm' | 'statutory' | 'job-plans' | 'classes' | 'verification'>,

  work: {
    area: 'Property', title: 'Work', basePath: '/property/work',
    description: 'Faults reported and the work orders that answer them: triage, assignment, the SLA clock, permits to work, completion and verification.',
    views: [
      { key: 'work-orders', label: 'Work orders' },
      { key: 'faults', label: 'Faults to triage' },
      { key: 'permits', label: 'Permits' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'faults': return <FaultsTab ctx={ctx} />;
        case 'permits': return <PermitsTab ctx={ctx} />;
        default: return <WorkOrdersTab ctx={ctx} />;
      }
    },
  } satisfies PropertySectionDef<'work-orders' | 'faults' | 'permits'>,

  contractors: {
    area: 'Property', title: 'Contractors and costs', basePath: '/property/contractors',
    description: 'Contractors and their clearances, maintenance contracts and scorecards, the cost of maintenance by asset, reliability, the budget, the capital replacement plan and warranty claims.',
    views: [
      { key: 'contractors', label: 'Contractors' },
      { key: 'contracts', label: 'Contracts' },
      { key: 'scorecards', label: 'Scorecards' },
      { key: 'invoices', label: 'Contractor invoices' },
      { key: 'costs', label: 'Costs and reliability' },
      { key: 'capital-plan', label: 'Capital plan' },
      { key: 'warranty', label: 'Warranty claims' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'contracts': return <ContractsTab ctx={ctx} />;
        case 'scorecards': return <ScorecardsTab />;
        case 'invoices': return <ContractorInvoicesTab ctx={ctx} />;
        case 'costs': return <CostsTab />;
        case 'capital-plan': return <CapitalPlanTab ctx={ctx} />;
        case 'warranty': return <WarrantyTab ctx={ctx} />;
        default: return <ContractorsTab ctx={ctx} />;
      }
    },
  } satisfies PropertySectionDef<'contractors' | 'contracts' | 'scorecards' | 'invoices' | 'costs' | 'capital-plan' | 'warranty'>,

  airport: {
    area: 'Property', title: 'Airport', basePath: '/property/airport',
    description: 'The airport pack: airfield and terminal inspections, findings and FOD, friction, lighting and pavement, the aerodrome\u2019s compliance, airside work control, availability, and the commercial specifics from passengers to the master plan.',
    views: [
      { key: 'inspections', label: 'Inspections' },
      { key: 'findings', label: 'Findings and FOD' },
      { key: 'airfield', label: 'Airfield' },
      { key: 'airside', label: 'Airside control' },
      { key: 'availability', label: 'Availability' },
      { key: 'commercial', label: 'Commercial' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'findings': return <FindingsTab ctx={ctx} />;
        case 'airfield': return <AirfieldTab ctx={ctx} />;
        case 'airside': return <AirsideTab ctx={ctx} />;
        case 'availability': return <AvailabilityTab ctx={ctx} />;
        case 'commercial': return <CommercialTab ctx={ctx} />;
        default: return <InspectionsTab ctx={ctx} />;
      }
    },
  } satisfies PropertySectionDef<'inspections' | 'findings' | 'airfield' | 'airside' | 'availability' | 'commercial'>,

  compliance: {
    area: 'Property', title: 'Compliance', basePath: '/property/compliance',
    description: 'What each portfolio must do and show: statutory and licence obligations with their evidence, regulators\u2019 audit findings with their corrective actions, and the evidence pack for an inspector.',
    views: [{ key: 'obligations', label: 'Obligations and findings' }],
    render: (_view, ctx) => <ComplianceTab ctx={ctx} />,
  } satisfies PropertySectionDef<'obligations'>,

  settings: {
    area: 'Property', title: 'Property Settings', basePath: '/property/settings',
    description: 'What the module calls things, the accounts billing posts to, the owners and portfolios, the location types, the sector packs, and who may see what.',
    views: [
      { key: 'general', label: 'General' },
      { key: 'owners', label: 'Owners' },
      { key: 'portfolios', label: 'Portfolios' },
      { key: 'types', label: 'Location types' },
      { key: 'packs', label: 'Sector packs' },
      { key: 'agreement-types', label: 'Agreement types' },
      { key: 'clause-templates', label: 'Clause templates' },
      { key: 'rates', label: 'Rates and indices' },
      { key: 'permit-kinds', label: 'Permit kinds' },
      { key: 'sla', label: 'SLA matrix' },
      { key: 'codes', label: 'Failure codes' },
      { key: 'access', label: 'Access' },
      { key: 'portal-users', label: 'Portal logins' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'agreement-types': return <AgreementTypesTab ctx={ctx} />;
        case 'clause-templates': return <ClauseTemplatesTab ctx={ctx} />;
        case 'rates': return <RatesTab ctx={ctx} />;
        case 'owners': return <OwnersTab ctx={ctx} />;
        case 'portfolios': return <PortfoliosTab ctx={ctx} />;
        case 'types': return <LocationTypesTab ctx={ctx} />;
        case 'packs': return <PacksTab ctx={ctx} />;
        case 'permit-kinds': return <PermitKindsTab ctx={ctx} />;
        case 'sla': return <SlaTab ctx={ctx} />;
        case 'codes': return <CodesTab ctx={ctx} />;
        case 'access': return <AccessTab ctx={ctx} />;
        case 'portal-users': return <PortalUsersTab ctx={ctx} />;
        default: return <SettingsTab ctx={ctx} />;
      }
    },
  } satisfies PropertySectionDef<'general' | 'owners' | 'portfolios' | 'types' | 'packs' | 'agreement-types' | 'clause-templates' | 'rates' | 'permit-kinds' | 'sla' | 'codes' | 'access' | 'portal-users'>,
};
